import { MapPin, Plane, TrainFront, Building2, Hospital, Coffee, GraduationCap, Sparkles } from "lucide-react";

const ROWS = [
  { label: "Full address", value: "To be added", icon: MapPin },
  { label: "Distance from Dehradun railway station", value: "Shared on enquiry", icon: TrainFront },
  { label: "Distance from Dehradun airport", value: "Shared on enquiry", icon: Plane },
  { label: "Distance from city centre", value: "Shared on enquiry", icon: Building2 },
  { label: "Nearby hospitals", value: "Shared on enquiry", icon: Hospital },
  { label: "Nearby cafés and restaurants", value: "Shared on enquiry", icon: Coffee },
  { label: "Nearby schools or institutions", value: "Shared on enquiry", icon: GraduationCap },
  { label: "Nearby attractions", value: "Shared on enquiry", icon: Sparkles },
];

export default function Location({ mapsEmbedUrl = "" }) {
  return (
    <section id="location" className="py-24 md:py-32 bg-[#EFEAE4]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5 reveal">
            <div className="text-[11px] uppercase tracking-[0.35em] text-[#985F47] mb-5">Location</div>
            <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tightest text-[#2C392F] font-light">
              Peaceful, <span className="italic text-[#985F47]">yet connected.</span>
            </h2>
            <div className="mt-8 space-y-5 text-[#4A4D4A] text-base md:text-lg leading-relaxed max-w-md">
              <p>
                ChiMano House offers the best of both worlds: the calm of a private foothills stay and the
                convenience of Dehradun. Mussoorie is approximately 21 km away, with a driving time of
                around 45 minutes, making the house well suited for guests who want to enjoy the hills
                without staying in the rush of a crowded hill town.
              </p>
              <p>
                A grocery store is located just outside the gate, so daily essentials remain easy to
                access during both short and extended stays.
              </p>
            </div>

            <dl className="mt-10 space-y-3">
              {ROWS.map((r, i) => {
                const Icon = r.icon;
                return (
                  <div
                    key={r.label}
                    data-testid={`location-row-${i}`}
                    className="flex items-start gap-4 py-3 border-b border-[#2C392F]/10"
                  >
                    <Icon size={18} className="text-[#6A7B61] mt-1 flex-shrink-0" strokeWidth={1.5} />
                    <div className="flex-1">
                      <dt className="text-[11px] uppercase tracking-[0.22em] text-[#985F47]">{r.label}</dt>
                      <dd className="serif text-lg text-[#2C392F] mt-1">{r.value}</dd>
                    </div>
                  </div>
                );
              })}
            </dl>
          </div>

          <div className="lg:col-span-7 reveal">
            <div className="relative aspect-[4/5] md:aspect-[5/6] rounded-2xl overflow-hidden border border-[#2C392F]/15 bg-[#F7F5F0]">
              {mapsEmbedUrl ? (
                <iframe
                  data-testid="location-maps-iframe"
                  src={mapsEmbedUrl}
                  title="ChiMano House location map"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="absolute inset-0 w-full h-full border-0"
                  allowFullScreen
                />
              ) : (
                <>
                  {/* Stylised map fallback */}
                  <svg viewBox="0 0 600 700" className="absolute inset-0 w-full h-full">
                    <defs>
                      <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                        <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#2C392F" strokeOpacity="0.08" strokeWidth="0.6" />
                      </pattern>
                    </defs>
                    <rect width="600" height="700" fill="#EFEAE4" />
                    <rect width="600" height="700" fill="url(#grid)" />
                    <path d="M -20 200 C 150 220, 300 150, 620 280" stroke="#6A7B61" strokeWidth="3" fill="none" strokeOpacity="0.35" />
                    <path d="M 80 -20 C 120 180, 300 350, 380 720" stroke="#6A7B61" strokeWidth="3" fill="none" strokeOpacity="0.35" />
                    <path d="M -20 520 C 220 480, 380 600, 620 540" stroke="#6A7B61" strokeWidth="2" fill="none" strokeOpacity="0.25" />
                    <path d="M 500 -10 C 460 200, 540 380, 480 720" stroke="#985F47" strokeWidth="6" fill="none" strokeOpacity="0.2" />
                    <g transform="translate(290 320)">
                      <circle r="68" fill="#2C392F" fillOpacity="0.08" />
                      <circle r="40" fill="#2C392F" fillOpacity="0.18" />
                      <circle r="14" fill="#985F47" />
                      <circle r="6" fill="#F7F5F0" />
                    </g>
                    <text x="320" y="330" fontFamily="Cormorant Garamond" fontSize="22" fill="#2C392F">
                      ChiMano House
                    </text>
                    <text x="320" y="352" fontFamily="Manrope" fontSize="11" fill="#4A4D4A" letterSpacing="2">
                      DEHRADUN · UTTARAKHAND
                    </text>
                  </svg>

                  <div className="absolute bottom-5 left-5 right-5 bg-[#F7F5F0]/95 backdrop-blur border border-[#2C392F]/10 rounded-xl px-5 py-4 flex items-center justify-between">
                    <div>
                      <div className="text-[10px] uppercase tracking-[0.3em] text-[#985F47]">Map placeholder</div>
                      <div className="serif text-lg text-[#2C392F] leading-tight mt-1">Exact location shared on confirmation</div>
                    </div>
                    <MapPin className="text-[#985F47]" strokeWidth={1.5} />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
